

import { queryClient } from '../state/queryClient';
import { axios_email_send } from '../axios/axios_email';

export const sendemail_o = async ({lead,email,email2,objet,message,attachments}) => {  
    const datasmessage = new FormData();
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);

    datasmessage.append("courtier",user['courtier']);
    datasmessage.append("Subject", objet);
    datasmessage.append("TextBody", message);
    datasmessage.append("From", user['postmail']);
    datasmessage.append("To",email);
    lead?.id && datasmessage.append("id_lead",lead.id);
    lead?.id_client && datasmessage.append("id_client",lead.id_client);
    email2 && datasmessage.append("email2",  email2);
    lead?.nom && datasmessage.append("nom",lead.nom);
    lead?.prenom && datasmessage.append("prenom",lead.prenom);

    for (let i = 0; i < attachments.length; i++) {datasmessage.append("attachments", attachments[i]);}
    const reqmail = await axios_email_send(datasmessage)


    return reqmail.data?.listelienspj?.[0]
};


export const sendemail = async ({lead,email,email2,objet,message,messagetexte,attachments}) => {  
    const datasmessage = new FormData();
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);

    datasmessage.append("courtier",user['courtier']);
    datasmessage.append("Subject", objet);
    datasmessage.append("HtmlBody", message);
    datasmessage.append("TextBody", messagetexte);
    datasmessage.append("From", user['postmail']);
    datasmessage.append("To",email);
    lead?.id && datasmessage.append("id_lead",lead.id);
    lead?.id_client && datasmessage.append("id_client",lead.id_client);
    email2 && datasmessage.append("email2",  email2);
    lead?.nom && datasmessage.append("nom",lead.nom);
    lead?.prenom && datasmessage.append("prenom",lead.prenom);

    

    for (let i = 0; i < attachments.length; i++) {datasmessage.append("attachments", attachments[i]);}
    const reqmail = await axios_email_send(datasmessage)


    return reqmail.data?.listelienspj?.[0]
};